module.exports = {
  factory: function lifetime() {
    return {
      time: 100
    };
  },
  reset: function(lifetime) {
    lifetime.time = 100;
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/components/lifetime.js
// module id = 192
// module chunks = 0